var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"flex flex-col"},[_vm._t("default"),(_vm.error)?_c('span',{staticClass:"my-1 text-red-600 text-xs"},[_vm._v(_vm._s(_vm.error))]):_vm._e()],2)}
var staticRenderFns = []

export { render, staticRenderFns }